
import { mapMutations, mapState } from 'vuex';
import ContactForm from '@/components/contactForm.vue';
import Staff from '@/components/staff.vue';
import ClinicMenu from '@/components/clinicMenu.vue';
import WpImage from '~/components/ui/img.vue';
import Slider from '@/components/ui/slider.vue';
import Block from '@/components/ui/block.vue';

export default {
  name: 'Clinic',

  components: {
    ContactForm,
    Staff,
    ClinicMenu,
    WpImage,
    Slider,
    Block,
  },

  async fetch() {
    try {
      const slug = this.$route.params.slug;
      const { data } = await this.$wp.clinics({ slug });
      if (data.length) {
        this.addClinic(data[0]);
      } else {
        return this.$nuxt.error({ statusCode: 404 });
      }
    } catch (_) {
      return this.$nuxt.error({ statusCode: 404 });
    }
    if (!this.staff?.length > 0) {
      const staff = await this.$wp.staff();
      this.setStaff(staff.data);
    }
  },

  computed: {
    ...mapState(['staff', 'patientId']),

    clinic() {
      return this.$store.getters.getClinic(this.$route.params.slug);
    },

    defaultBlock() {
      return this.clinic.acf.default_blocks
        ? this.clinic.acf.default_blocks[0]
        : null;
    },
  },

  mounted() {
    this.$bolev.metaEvent({
      type: 'pageView',
      patientId: this.patientId,
    });
  },

  methods: {
    ...mapMutations(['addClinic', 'setStaff']),

    getLinkToMaps(address) {
      return `https://www.google.com/maps/place/${address}`;
    },
  },

  head() {
    if (this.clinic) {
      return this.$seo.yoast(this.clinic.yoast_head_json);
    }
  },
};
